import { render, staticRenderFns } from "./timeOrd.vue?vue&type=template&id=c6d60e24&scoped=true"
import script from "./timeOrd.vue?vue&type=script&lang=js"
export * from "./timeOrd.vue?vue&type=script&lang=js"
import style0 from "./timeOrd.vue?vue&type=style&index=0&id=c6d60e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d60e24",
  null
  
)

export default component.exports